.ka{pointer-events:auto;}